import React, { useEffect, useRef, useState } from "react";
import { getProduct, getRandomProducts } from "../../configs/productsConfig";
import { useNavigate, useParams } from "react-router-dom";
import { domain, serverURL } from "../../configs/auth";
import { DeliveryComponent }from "../../components/DeliveryComponents";
import { ProductCard } from "../../components/Cards";
import { addBasket } from "../../configs/ordersConfig";
import { trackAddToCart } from "../../configs/analytics";
import { Helmet } from "react-helmet-async";
import AliceCarousel from "react-alice-carousel";


function ProductDetail() {


    const { tableName, slugUUID } = useParams();
    const navigate = useNavigate();
    
    const [productSlug, productId] = slugUUID.split("__");
    const [product, setProduct] = useState('');
    const [randomProducts, setRandomProducts] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedImage, setSelectedImage] = useState("");
    const [orderedPiece, setOrderedPiece] = useState(1);
    const [productDetails, setProductDetails] = useState([{ id: "", option: "", stock: "", price: "", discountPrice: "", weight: "" , unitType: ""}]);

    const productsCarousel = randomProducts
        ? randomProducts.map((product) => (
            <div className="h-100 p-3">
                <ProductCard
                    key={product.product_id}
                    tableName={product.table_name}
                    product={product}
                    page="Home"
                />
            </div>
        ))
        : [];

    const prices = productDetails.map(p => Number(p.discountPrice ?? p.price));
    const lowPrice = Math.min(...prices);
    const highPrice = Math.max(...prices);

    const imagesArray = product ? (
        Array.isArray(product.images)
            ? product.images
            : product.images?.split(',').map(image => image.trim()) || []
    ) : [];

    useEffect(() => {
        if (product && product.product_details) {
            let details;
            if (product.product_details.includes(",")) {
                details = product.product_details.split(",").map((optionStr) => {
                    const [id, option, stock, price, discountPrice, weight, unitType] = optionStr.split(":");
                    return { id, option, stock, price, discountPrice: discountPrice === "NULL" ? null : discountPrice, weight, unitType};
                });
            } else {
                const [id, option, stock, price, discountPrice, weight, unitType] = product.product_details.split(":");
                details = [{ id, option, stock, price, discountPrice: discountPrice === "NULL" ? null : discountPrice, weight, unitType}];
            }
            setProductDetails(details);
        }
        const fetchRandomProducts = async () => {
            try {
                const data = await getRandomProducts();
                setRandomProducts(data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchRandomProducts();
    }, [product]);

    useEffect(() => {
        const fetchData = async () => {
            if (!tableName || !productId) return navigate("/not-found");

            try {
                const data = await getProduct(tableName, productId);
                if (!data) return navigate("/not-found");
                setProduct(data);
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        };
        setSelectedImage('');

        fetchData();
    }, [tableName, productId]);

    useEffect(() => {
        if (product) {
            const imagesArray = Array.isArray(product.images)
                ? product.images
                : product.images?.split(',').map(image => image.trim()) || [];

            if (imagesArray.length > 0 && !selectedImage) {
                setSelectedImage(imagesArray[0]);
            }
        }
    }, [product]);


    const handleOrderedPiece = (change) => {
        let updatedPiece = Math.max(1, Math.min(productDetails[selectedIndex].stock, orderedPiece + change));
        setOrderedPiece(updatedPiece);
    };

    const handleOptionChange = (event) => {
        setSelectedIndex(event.target.selectedIndex);
        setOrderedPiece(1);
    };

    const addProductToBasket = () => {
        addBasket({ 'tableName': tableName, 'productId': product.product_id, 'productName': product.name, 'productOptionId': productDetails[selectedIndex].id, 'productOption': productDetails[selectedIndex].option, 'quantity': orderedPiece, 'unitType': productDetails[selectedIndex].unitType });
        trackAddToCart(product, orderedPiece, productDetails[selectedIndex].option);
    }; 


    return (
        <div className='container-fluid p-0'>
            <Helmet>
                <title>{`${product.name} - Kreatív Örömök`}</title>
                <meta name="description" content={product.description} />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": product.name,
                        "image": imagesArray,
                        "description": product.description,
                        "sku": product.product_id,
                        "brand": { "@type": "Brand", name: "Kreatív Örömök" },
                        "offers": productDetails.length > 1 ? {
                            "@type": "AggregateOffer",
                            priceCurrency: "HUF",
                            lowPrice: lowPrice,
                            highPrice: highPrice,
                            offerCount: productDetails.length,
                            availability: "https://schema.org/InStock"
                        } : { "@type": "Offer", 
                            priceCurrency: "HUF", 
                            price: productDetails[selectedIndex].discountPrice === null ? productDetails[selectedIndex].price : productDetails[selectedIndex].discountPrice, 
                            availability: "https://schema.org/InStock"}
                    })}
                </script>
            </Helmet>


            <div className='container-lg d-flex flex-column flex-sm-row col-12 justify-content-around my-3'>

                <div className={`d-flex flex-column-reverse flex-md-row justify-content-center align-items-center col-md-6`}>

                    <div className={`${imagesArray.length > 1 ? '' : 'd-none'} overflow-auto col-md-2 d-flex flex-md-column gap-1 mt-2`} style={{
                        scrollbarWidth: "none",
                    }}>
                       
                            {
                                imagesArray.map((image, index) => (
                                    <img
                                        key={index}
                                        alt="product img"
                                        className="img-fluid pb-2 pe-2"
                                        src={`${image}`}
                                        onClick={() => setSelectedImage(image)}
                                        style={{ cursor: 'pointer', maxHeight: '100px' }}
                                    />
                                ))
                            }
                    </div>

                    <img
                        alt="product img"
                        className="img-fluid col-md-9 img-thumbnail"
                        style={{maxHeight: '350px'}}
                        src={`${selectedImage}`}
                    />
                </div>

                <div className="d-flex flex-column justify-content-center align-items-center ms-sm-3 col-sm-5">

                    <div className="w-100">
                        <h2 className="mb-sm-4 mb-3 mt-2">{product.name}</h2>
                        
                        <div className="d-flex flex-row col-12">
                            <h5 className="mb-sm-4 me-sm-4">{productDetails[selectedIndex].discountPrice === null ? productDetails[selectedIndex].price : productDetails[selectedIndex].discountPrice} Ft / {productDetails[selectedIndex].unitType === 'piece' ? 'Darab' : 'Csomag'}</h5>
                            <h6 className="text-danger text-decoration-line-through">{productDetails[selectedIndex].discountPrice === null ? '' : productDetails[selectedIndex].price + 'Ft'}</h6>
                        </div>

                        <p>{productDetails[selectedIndex].stock != 0 ? `Készleten: ${productDetails[selectedIndex].stock}` : 'Rendelhető'}</p>

                        <select className={`form-select mb-3 ${productDetails[0].option === '1' ? 'd-none' : ''}`} onChange={handleOptionChange}>
                            {
                                productDetails.map((detail, index) => (
                                    <option value={detail.option} key={index}>{detail.option}</option>
                                ))
                            }
                        </select>
                    </div>


                    <div className="d-flex flex-row col-12 align-items-center justify-content-center justify-content-md-start mb-2">
                        <div className="d-flex col-7">
                            <button className="btn bg-white rounded-0 rounded-start border" onClick={() => handleOrderedPiece(-1)}>-</button>
                            <span className="form-control px-1 w-25 rounded-0 border-start-0 border-end-0 text-center">{orderedPiece}</span>
                            <button className="btn bg-white rounded-0 rounded-end border" onClick={() => handleOrderedPiece(+1)}>+</button>
                        </div>
                        <button className='btn-card rounded-4 py-2 px-3 me-1' disabled={productDetails[selectedIndex].stock == 0} onClick={addProductToBasket}>Kosárba</button>
                    </div>
                </div>
            </div>

            <div className='container-lg d-flex flex-column flex-md-row col-12 justify-content-around border-bottom mt-2'>

                <div className="col-md-6 d-flex flex-column">
                    <p className="text-justify px-2" style={{whiteSpace: 'pre-line'}}>{product.description}</p>
                    <a className={`${tableName === 'prepared_materials' ? '' : 'd-none'}`} href={domain + product.guide}>Útmutató a termék elkészítéséhez</a>
                </div>

                <div className="col-md-6 mx-2">
                    <DeliveryComponent />
                </div>

            </div>


            <div className="container-lg border-top px-0 py-4">
                    <h2 className="h2-home ps-2 m-0">További termékek</h2>
                    {productsCarousel.length > 0 ? (
                        <AliceCarousel
                            autoPlay
                            autoPlayInterval={3500}
                            animationDuration={700}
                            infinite
                            pauseOnHover
                            mouseTracking
                            disableButtonsControls
                            responsive={{
                                0: { items: 2 },
                                576: { items: 3 },
                                768: { items: 4 },
                            }}
                            items={productsCarousel}
                        />
                    ) : (
                        <p>Nincs termék</p>
                    )}
                </div>

        </div>
    );
};

export default ProductDetail;